import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { LoadingScreen } from './LoadingScreen';
import { ExperienceTableHeader } from './ExperienceTableHeader';
import { ExperienceTablePageGroupSubHeader } from './ExperienceTablePageGroupSubHeader';
import { ExperienceTableRow } from './ExperienceTableRow';
import { ErrorScreen } from './ErrorScreen';
import { IStore } from '../../domain/store';
import config from '../../config';

interface IProps {
  store?: IStore;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: auto;
  margin-left: auto;
  width: 90%;
`;

@inject('store')
@observer
export class ExperienceTable extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { portfolioReportStore, goalStore, organizationStore } = this.store;
    if (portfolioReportStore.isLoading) {
      return <LoadingScreen />;
    } else if (portfolioReportStore.experienceList.length > 0) {
      let currentPageTag: string | null = null;
      let subHeader = null;
      return (
        <Wrapper>
          <ExperienceTableHeader />
          {portfolioReportStore.experienceList.map(experience => {
            if (currentPageTag !== experience.pageTag.ja) {
              currentPageTag = experience.pageTag.ja;
              subHeader = <ExperienceTablePageGroupSubHeader pageGroupName={experience.pageTag.ja} />;
            } else {
              subHeader = null;
            }
            return (
              <React.Fragment key={experience.id}>
                {subHeader}
                <ExperienceTableRow
                  experience={experience}
                  reportFrom={portfolioReportStore.portfolioReport.from}
                  selectedGoalId={goalStore.selectedGoalId}
                />
              </React.Fragment>
            );
          })}
        </Wrapper>
      );
    } else {
      return (
        <Wrapper>
          {portfolioReportStore.hasFilters ? (
            <ErrorScreen
              title={'絞り込みの条件に一致するエクスペリエンスはありません'}
              message={'絞り込みの条件を変更してみてください。'}
              actionLabel=""
              action={() => {}}
            />
          ) : (
            <ErrorScreen
              title={'エクスペリエンスを作成しましょう！'}
              message={'選択中のゴールを設定したエクスペエンスが存在しません。エクスペリエンスを作成しましょう。'}
              actionLabel="エクスペリエンスを作成する"
              action={() =>
                window.open(`${config.dashboard}/users/${organizationStore.selectedOrganizationId}/experiments`)
              }
            />
          )}
        </Wrapper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/ExperienceTable.tsx